import { ReactElement } from 'react';
import classNames from 'classnames';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';

import styles from './Button.module.scss';

interface IProps extends IconButtonProps {
  className?: string;
  disabled?: boolean;
}

const ButtonIcon = ({ className, disabled, children, ...props }: IProps): ReactElement => (
  <IconButton
    {...props}
    disabled={disabled}
    className={classNames({ [styles.disabled]: disabled }, className)}
  >
    {children}
  </IconButton>
);

export default ButtonIcon;
